import { invokeApi } from "../../bl_libs/ApiCalling";
import MaterialTable from "material-table";
import React, { useState, useEffect } from "react";
import { forwardRef } from "react";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import DeleteIcon from "@material-ui/icons/Delete";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";

///-------dialog-transition-------///
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
///-----------------CSS-Classes---------------///
const useStyles = makeStyles({
  hed: {
    fontWeight: "bold",
  },
  clmwdth: {
    width: "10px",
  },
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  btnadd: {
    float: "right",
    margin: 10,
  },
});

function PhoneErrorLogs(props) {
  console.log(props, "propsssss");
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [del, setDel] = React.useState(false);
  const [selectedrow, setrowdata] = React.useState([]);
  const [isLoading, setIsLoading] = useState(true);
  let [data, setData] = useState([]);
  ///---------------------Functions-------------------///
  const cheklat = (lat) => {
    if (lat === 0) {
      return "N/A";
    } else {
      return lat;
    }
  };
  const handleClickOpen = (rowdata) => {
    setrowdata(rowdata);
    setOpen(true);
  };

  const handleClose = () => {
    setDel(false);
    setOpen(false);
  };
  const handlemoveSize = () => {
    props.history.push({
      pathname: "/admin/add-move",
      state: { route: "move-size" },
    });
  };
  const handleAgreeClose = () => {
    data = data.filter(function (obj) {
      return obj.id !== selectedrow.id;
    });
    setData(data);
    const move_id = selectedrow.id;
    const token = localStorage.getItem("token");
    let requestObj = {
      path: `/api/admin/delete_move_type/${move_id}`,
      method: "DELETE",
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      console.log(res.code, "Service Delete response?");
      if (res.code === 200) {
        FetchPhoneVarificationLogs();
      } else {
        setDel(true);
      }
    });
    setOpen(false);
  };

  const FetchPhoneVarificationLogs = () => {
    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/api/admin/list_phone_verification_logs",
      method: "POST",
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      console.log(res, "RESPONSE");
      if (res.code === 200) {
        setData(res.getallphoneverifcationcodelist);
        setIsLoading(false);
      }
    });
  };
  useEffect(() => {
    FetchPhoneVarificationLogs();
  }, []);

  const [columns, setColumns] = useState([
    {
      title: <span className={classes.hed}>#</span>,
      width: 150,
      render: (rowData) => <>{rowData.tableData.id + 1}</>,
    },
    {
      title: <span className={classes.hed}>Phone Number</span>,
      field: "phone_number",
      sorting: false,
    },
    {
      title: <span className={classes.hed}>Date and Time</span>,
      render: (rowData) => <>{moment(rowData.created_at).format("LLLL")}</>,
      sorting: false,
    },
    {
      title: <span className={classes.hed}>Error Log Message</span>,
      field: "log",
      sorting: false,
    },
  ]);
  ///-------------styling-icons---------------------///

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => (
      <Edit className={classes.Icons} {...props} ref={ref} />
    )),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    DeleteIcon: forwardRef((props, ref) => <DeleteIcon {...props} ref={ref} />),
  };

  if (isLoading) {
    return (
      <div className="Circular-Progress">
        <CircularProgress color="primary" />
      </div>
    );
  }
  return (
    <>
      <MaterialTable
        style={{ marginTop: "55px" }}
        // actions={[
        //   {
        //     icon: () => <Edit style={{ fill: "#00000" }}></Edit>,
        //     tooltip: "Edit move",
        //     onClick: (event, rowData) => {
        //       props.history.push({
        //         pathname: `/admin/edit-move/${rowData.id}`,
        //       });
        //     },
        //   },
        //   {
        //     icon: () => <DeleteIcon style={{ fill: "#00000" }}></DeleteIcon>,
        //     tooltip: "Delete move",
        //     iconProps: { style: { fontSize: "14px", color: "#000000" } },
        //     onClick: (event, rowData) => {
        //       handleClickOpen(rowData);
        //     },
        //   },
        // ]}
        title="Phone Error Logs"
        // Fixed hanging problem on ReRendering
        columns={columns.map((c) => ({ ...c, tableData: undefined }))}
        data={data}
        icons={tableIcons}
        options={{
          actionsColumnIndex: -1,
          search: true,
          searchFieldAlignment: "right",
          searchFieldStyle: {},
          searchFieldVariant: "standard",
          pageSize: 25,
          pageSizeOptions: [25, 50, 100, 200],
          emptyRowsWhenPaging: false,
          headerStyle: {
            backgroundColor: "#c4314b",
            color: "white",
            fontWeight: "bold",
          },
        }}
      />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{`Are you sure you want to Delete Move " ${selectedrow.name}" ?`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {selectedrow.zip_code}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Disagree
          </Button>
          <Button onClick={handleAgreeClose} color="primary">
            Agree
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={del}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{`Something get wrong!`}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default withRouter(PhoneErrorLogs);
